import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateSearchFields from "@MasterBluePrint/Store/Pages/RfqMyQuotes/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Tag, { horizontalStyles, TagPresentationProps } from "@insite/mobius/Tag";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomApplicationState } from "@MasterBluePrint/Store/CustomApplicationState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => {

    return {
        filtersOpen: state.rfqMyQuotes.filtersOpen,
        getQuotesParameter: state.rfqMyQuotes.getQuotesParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

export interface QuoteSearchTagsStyles {
    appliedFiltersContainer?: InjectableCss;
    appliedFilterTag?: TagPresentationProps;
}

export const quoteSearchTagsStyles: QuoteSearchTagsStyles = {
    appliedFiltersContainer: {
        css: css`
            border-top: 1px solid #E4E8F0;
            padding-top: 5px;
            margin-top: -5px;
            position: relative;
            z-index: 1;
            
            .applied-filter-title {
                color: #333F48;
                font-family: 'Roboto',sans-serif;
                font-size: 14px;
                font-weight: 600;
                margin: 6px 10px 6px 0;
                display:inline-flex;
                max-width: 260px;
            }

            > div {
                background-color: #E5EEF7;
                border: 1px solid #2060AD;
                padding: 2px 0 2px 5px;
                min-height: 2px;
                border-radius: 0;
                font-size: 14px;
                line-height: 18px;
                display: inline-flex;
                margin: 6px 10px 6px 0;

                button {
                    background-color: #E5EEF7;
                    height: 18px;
                    position: relative;
                    top: -1px;
                    
                    &:hover,
                    &:focus,
                    &:active {
                        background: none;
                        border: none;
                    }

                    svg {
                        height: 18px;
                        width: 18px;
                    }
                }
            }
        `,
    },
};

const styles = quoteSearchTagsStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const QuoteSearchTags = ({ getQuotesParameter, updateSearchFields }: Props) => {
    const fieldRemoveHandler = (fieldName: string, value = "") => {
        updateSearchFields({ [fieldName]: value });
    };
    
    return (
        <>
            {getQuotesParameter.orderNumber || getQuotesParameter.expireFromDate || getQuotesParameter.expireToDate || getQuotesParameter.fromDate || getQuotesParameter.toDate ||
                getQuotesParameter.requestedBy || getQuotesParameter.quoteTotalOperator || getQuotesParameter.amount ? (
                <StyledWrapper {...styles.appliedFiltersContainer}>
                    <Typography as="span" className="applied-filter-title">Filters:</Typography>
                    {getQuotesParameter.orderNumber && (
                        <Tag
                            {...styles.appliedFilterTag}
                            onDelete={() => {
                                fieldRemoveHandler("orderNumber");
                            }}
                        >
                            {`${translate("Quote #")}: ${getQuotesParameter.orderNumber}`}
                        </Tag>
                    )}
                    {getQuotesParameter.fromDate && (
                        <Tag
                            {...styles.appliedFilterTag}
                            onDelete={() => {
                                fieldRemoveHandler("fromDate");
                            }}
                        >
                            {`${translate("From Date")}: ${getQuotesParameter.fromDate}`}
                        </Tag>
                    )}
                    {getQuotesParameter.toDate && (
                        <Tag
                            {...styles.appliedFilterTag}
                            onDelete={() => {
                                fieldRemoveHandler("toDate");
                            }}
                        >
                            {`${translate("To Date")}: ${getQuotesParameter.toDate}`}
                        </Tag>
                    )}
                    {getQuotesParameter.expireFromDate && (
                        <Tag
                            {...styles.appliedFilterTag}
                            onDelete={() => {
                                fieldRemoveHandler("expireFromDate");
                            }}
                            data-test-selector="orderHistoryTags_FromDate"
                        >
                            {`${translate("Expire From Date")}: ${getQuotesParameter.expireFromDate}`}
                        </Tag>
                    )}
                    {getQuotesParameter.expireToDate && (
                        <Tag
                            {...styles.appliedFilterTag}
                            onDelete={() => {
                                fieldRemoveHandler("expireToDate");
                            }}
                        >
                            {`${translate("Expire To Date")}: ${getQuotesParameter.expireToDate}`}
                        </Tag>
                    )}                    
                    {/* {getQuotesParameter.requestedBy && (
                        <Tag
                            {...styles.appliedFilterTag}
                            onDelete={() => {
                                fieldRemoveHandler("requestedBy");
                            }}
                        >
                            {`${translate("Requeste dBy")}: ${getQuotesParameter.requestedBy}`}
                        </Tag>
                    )} */}
                    {getQuotesParameter.quoteTotalOperator && getQuotesParameter.orderTotal && (
                        <Tag
                            {...styles.appliedFilterTag}
                            onDelete={() => {
                                fieldRemoveHandler("quoteTotalOperator");
                                fieldRemoveHandler("amount");
                            }}
                        >
                            {`${translate("Amount")}: ${getQuotesParameter.quoteTotalOperator} ${getQuotesParameter.orderTotal
                                }`}
                        </Tag>
                    )}                   
                </StyledWrapper>
            ) : ''}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(QuoteSearchTags),
    definition: {
        group: "RFQ My Quotes",
        displayName: "Tags",
    },
};

export default widgetModule;
